import { App } from "../../constant";
import MenuFilter, { MenuFilterProps } from "../menuFilter";

interface MenuData {
  key: string;
  title: string;
  children?: MenuData[];
}

type Result = { label: string; value: string }[];

/** 将菜单数据转换为Select组件选项 */
export const convertMenuDataToSelectOptions = (data: MenuData[]) => {
  const res: Result = [];
  const loop = (list: MenuData[]) => {
    list.forEach((item) => {
      res.push({
        label: item.title,
        value: item.key,
      });
      if (item.children) {
        loop(item.children);
      }
    });
  };
  loop(data);
  return res;
};

/** 深度搜索 */
export const deepSearchPath = (data: MenuData[], key: string) => {
  const path: string[] = [];
  let isEnd = false;
  const loop = (list: MenuData[]) => {
    for (const item of list) {
      if (item.key === key) {
        path.push(item.key);
        isEnd = true;
        break;
      }
      if (item.children) {
        path.push(item.key);
        loop(item.children);
        if (isEnd) {
          break;
        }
        path.pop();
      }
    }
  };
  loop(data);
  return path;
};

/** 菜单筛选组件 */
export const menuFilterMap: Partial<
  Record<App, React.FC<MenuFilterProps> | undefined>
> = {
  [App.WE_OPP]: MenuFilter,
};
